module.exports = __webpack_public_path__ + "static/media/Mobile_Data_INTELIGENCIA_EM_CYBERSECURITY_COM_SOLUCOES_OPEN_SOURCE-13.81939522.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Intel_em_Cybersecurity/Mobile_Data_INTELIGENCIA_EM_CYBERSECURITY_COM_SOLUCOES_OPEN_SOURCE-13.png
// module id = 66
// module chunks = 0